const CardsInfoSkeleton = () => (
  <div className="cards-holder-card cards-holder-card--skeleton" aria-hidden="true">
    <div className="cards-info-skeleton">
      <div className="cards-info-skeleton__item" />
      <div className="cards-info-skeleton__item" />
      <div className="cards-info-skeleton__item" />
    </div>
  </div>
);

export default CardsInfoSkeleton;
